import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Checklist from "../images/BC-Checklist.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch } from "react-redux";
import { setUser } from "../../redux/actions";

const PageChecklist = () => {
    const dispatch = useDispatch();

    const [busy, setBusy] = useState(false);
    const handleSubmitId = async (event) => {
        event.preventDefault();
        setBusy(true);
        await axios
            .patch("/api/creators", {
                id_submitted: true,
            })
            .then((response) => {
                dispatch(setUser());
                setBusy(false);
                window.location.href =
                    "mailto:creators@privaposts.com?subject=Submit ID for Creator ID verification.";
                // window.open(
                //     'https://privaposts.zendesk.com/hc/en-us/requests/new',
                //     '_blank'
                // ).focus();
            })
            .catch((error) => {
                setBusy(false);
            });
    };

    return (
        <div className="panel panel-default" id="step1">
            <div className="panel-heading refpayout">
                <span className="BC-head-ico">
                    <LazyLoadImage src={Checklist} />
                </span>
                <span>Creator Page Checklist:</span>
            </div>
            <div className="page-checklist panel-body">
                <ul className="page-checklist-ul fa-ul">
                    <li>
                        <span>
                            <FontAwesomeIcon icon={["fas", "circle"]} />
                        </span>
                        <div>
                            <h6>Step 1 - Submit ID for verification</h6>
                            <p>
                                Creators must be 18 and over. Two forms of valid
                                Government issued ID is required for all
                                creators in order to verify your account. You do
                                not have to wait for our approval to launch your
                                profile, however you will not receive any
                                payouts and your account will be shut down
                                within 7 days without a valid ID.
                            </p>
                            <p>
                                If you are under 18 years of age or attempt to
                                use fake identification or someone else’s
                                identification stop right now as you have not
                                only breached our terms (which you legally
                                agreed to when you signed up), you have also
                                broken the law and you will be reported to the
                                authorities. Your IP address and login data will
                                be submitted to the police.
                            </p>
                            <p>
                                We have zero tolerance for crimes such as
                                Identity theft and underage sexual content /
                                porn or content depicting minors in a sexual
                                fashion.
                            </p>
                            <p>**Please include username in your submission*</p>
                            <button
                                className="btn theme-btn theme-btn-bordered submit-id-btn"
                                onClick={handleSubmitId}
                                disabled={busy}
                            >
                                {busy ? "Please wait..." : "Submit ID"}
                            </button>
                        </div>
                    </li>
                    <li>
                        <span>
                            <FontAwesomeIcon icon={["fas", "circle"]} />
                        </span>
                        <div>
                            <h6>Step 2 - Subscription plans</h6>
                            <p>
                                Is the only step needed to post content and earn
                                money from subscribers!
                            </p>
                        </div>
                    </li>
                    <li>
                        <span>
                            <FontAwesomeIcon icon={["fas", "circle"]} />
                        </span>
                        <div>
                            <h6>Step 3 - Profile & cover photos</h6>
                            <p>Attract your followers!</p>
                        </div>
                    </li>
                    <li>
                        <span>
                            <FontAwesomeIcon icon={["fas", "circle"]} />
                        </span>
                        <div>
                            <h6>Step 4 - Basic Profile Details</h6>
                            <p>
                                Set your creator details and make a great first
                                impression.
                            </p>
                        </div>
                    </li>
                    <li>
                        <span>
                            <FontAwesomeIcon icon={["fas", "circle"]} />
                        </span>
                        <div>
                            <h6>
                                Step 5 - Welcome Message for New Subscribers
                            </h6>
                            <p>
                                Setup a welcome message that is automatically
                                sent to new subscribers with an optional Pay Per
                                View (PPV) media file attachment.
                            </p>
                        </div>
                    </li>
                    <li>
                        <span>
                            <FontAwesomeIcon icon={["fas", "circle"]} />
                        </span>
                        <div>
                            <h6>Step 6 - Payout preference</h6>
                            <p>Only required to receive your earnings</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default PageChecklist;
